import { render } from "./MypageTop.vue?vue&type=template&id=cfa93cec"
import script from "./MypageTop.vue?vue&type=script&lang=js"
export * from "./MypageTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__